<script>

    /**
     * Vue Component to use with "inline-template" in twig templates.
     *
     * As long as it is inside a parent vue-container (see "utils/vueContainer")
     * is mounted automatically and can be nested as far as you want.
     *
     * <carousel inline-template>
     *    <div class="carousel">
     *    </div>
     * </carousel>
     *
     *
     */
    export default {

        name: 'Carousel',

        data() {
            return {};
        },

        mounted() {
            console.log('Component ready.');
        }

    };
</script>
